module.exports = __webpack_public_path__ + "img/notice.f263db0e.png";